/**
 * Registro del Service Worker
 *
 * Registra el SW solo en producción y en navegadores que lo soporten.
 */

export function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(registration => {
          console.log('SW registrado:', registration.scope);
        })
        .catch(error => {
          console.error('Error registrando SW:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
